import { connect } from 'react-redux'
import LeaguePlugin from '../../components/league-plugin'

const mapStateToProps = state => ({...state.leaguePlugin})

const mapDispatchToProps = dispatch => ({
})

export default connect(mapStateToProps, mapDispatchToProps)(LeaguePlugin)
